/* template */
<template><order-common-card title="乘车人"><mpx-view v-for="(item, index) in (list)" @tap="checkPassenger(item)" :key="item.index" class="passenger"><es-icon size="18" name="square" class="passenger-check" v-if="(!item.__checked)"/><es-icon :class="({'passenger-check':true,checked:!disabled})" size="18" name="check-square" v-else/><div class="passenger-info"><div class="passenger-info-name">{{item.passenger_name}}</div><div class="passenger-info-id">{{item.passenger_id_no}}</div></div></mpx-view></order-common-card></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0f51be6d"}'>
  @import '~@/mixins/stylus/color.styl'
	
	.passenger
		height 65px
		display flex
		align-items center
		border-bottom 1px solid RGBA(0, 0, 0, 0.04)
		&:last-child
			border none
		&-check
			color $train-color-999
			&.checked
				color $train-color-theme-blue
		&-info
			margin-left 13px
			letter-spacing 0px
			font-weight normal
			&-name
				font-family PingFangSC-Medium
				font-size 15px
				line-height 18px
				color #333333
			&-id
				font-family PingFangSC-Regular
				font-size 13px
				line-height 16px
				color #999999
				margin-top 5px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0f51be6d"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./passenger-change-check-list.mpx.js?isComponent&outputPath=components%2Fpassenger-change-check-list0f51be6d%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./passenger-change-check-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fpassenger-change-check-list0f51be6d%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0f51be6d"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/passenger-change-check-list0f51be6d/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'order-common-card':getComponent(require("../../../components/order-common-card/index.mpx?isComponent&outputPath=components%2Findexc3d6ce32%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
